import React from 'react';
import { Box, Typography } from '@mui/material';
import PageHero from '../ui/pageHero/PageHero';

const PrivacyPage = () => (
    <>
        <PageHero eyebrow="Legal" title="Privacy" />

        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 8, md: 12 }, px: '6%' }}>
            <Box sx={{ maxWidth: 700, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 4 }}>
                <Typography variant="body1">
                    This site is a static portfolio and design concept project. It does
                    not run analytics, does not set tracking cookies, and does not
                    collect or store personal data submitted through it.
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Any contact details shown on this site (such as the email address
                    on the Contact page) are illustrative and part of the fictional
                    Nexora concept — not a monitored business inbox.
                </Typography>
            </Box>
        </Box>
    </>
);

export default PrivacyPage;
